export default "__VITE_ASSET__B0ApWtzc__"